import React, { useEffect, useContext, useMemo } from 'react';

import cookie from 'react-cookies';
import { useNavigate, useLocation } from 'react-router-dom';

import Home from './Home';

import Layout from '../components/common/Layout';
import { UserContext } from '../context/UserContext';

const SetTokenPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = useMemo(() => new URLSearchParams(location.search), [location]);
  const token = query.get('token');
  const refresh = query.get('refresh');
  const destination = query.get('app');
  const role = query.get('role');
  const objectId = query.get('object_id');
  const { setToken } = useContext(UserContext);

  useEffect(() => {
    if (token && refresh) {
      setToken(token);
      cookie.save('lendistry_tokens_access', token, { path: '/' });
      cookie.save('lendistry_tokens_refresh', refresh, { path: '/' });
      if (role && objectId) {
        navigate(`/product/1/application/${objectId}`);
        return;
      }
      navigate(destination || '/dashboard');
    }
  }, [destination, objectId, refresh, role, setToken, token]);

  if (token) {
    return (
      <Layout>
        <div className="plaid page" />
      </Layout>
    );
  } else {
    return <Home />;
  }
};

export default SetTokenPage;
